<template>
  <div class="policy-page">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol lg="10" md="12">
          <div class="back-button-container">
            <CButton color="primary" variant="outline" @click="goBack">
              Back to Dashboard
            </CButton>
          </div>
          <CCard class="policy-card">
            <CCardBody>
              <h1 class="policy-title">Privacy Policy</h1>
              
              <div class="policy-content">
                <h2>Our Commitment to Your Privacy</h2>
                
                <p>At <strong>Scienlabs Technologies</strong>, your privacy and the security of your personal information are our top priority. We comply with the <strong>General Data Protection Regulation (GDPR)</strong> and are committed to handling your data with transparency, fairness, and care.</p>
                
                <h3>What this means for you:</h3>
                
                <ul>
                  <li>✅ <strong>We only collect what we need</strong> – We use your data strictly for fraud prevention, security, and improving our services.</li>
                  <li>✅ <strong>You stay in control</strong> – You can access, update, or request deletion of your personal data at any time.</li>
                  <li>✅ <strong>We protect your data</strong> – We apply strong security measures (encryption, access controls, monitoring) to keep your data safe.</li>
                  <li>✅ <strong>We don't misuse your data</strong> – We never sell your personal information to third parties.</li>
                  <li>✅ <strong>Trusted partners only</strong> – If we share data with third parties (e.g., fraud detection or payment providers), it's only with trusted partners under strict GDPR-compliant agreements.</li>
                  <li>✅ <strong>Global protection</strong> – If data is transferred outside the EU/EEA, we ensure it's protected by approved safeguards.</li>
                </ul>
                
                <h3>Your Rights</h3>
                
                <p>Under GDPR, you have the right to:</p>
                
                <ul>
                  <li>Access your personal data</li>
                  <li>Request corrections or deletions</li>
                  <li>Restrict or object to processing</li>
                  <li>Request a copy of your data in a portable format</li>
                </ul>
                
                <p>To exercise these rights or ask questions about how we handle your information, contact our DPO:</p>
                
                <div class="contact-box">
                  <h3>Data Protection Officer (DPO)</h3>
                  <p>
                    <strong>Name:</strong> Nadeem Kazi<br>
                    <strong>Email:</strong> <a href="mailto:dpo@scienlabs.com">dpo@scienlabs.com</a>
                  </p>
                </div>
                
                <p class="security-note">🔒 At <strong>Scienlabs Technologies</strong>, safeguarding your personal data is not just a legal obligation — it's a responsibility we take seriously.</p>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  methods: {
    goBack() {
      this.$router.push('/dashboard')
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
.policy-page {
  min-height: 100vh;
  padding: 2rem 0;
  background: #f0f3f5;
}

.back-button-container {
  margin-bottom: 1rem;
}

.policy-card {
  margin-bottom: 2rem;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
}

.policy-title {
  color: #2f353a;
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  border-bottom: 2px solid #e4e7ea;
  padding-bottom: 1rem;
}

.policy-content {
  color: #5c6873;
  line-height: 1.8;
  font-size: 1.05rem;
}

.policy-content h2 {
  color: #2f353a;
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-size: 1.8rem;
}

.policy-content h3 {
  color: #2f353a;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-size: 1.4rem;
}

.policy-content ul {
  margin: 1rem 0;
  padding-left: 2rem;
}

.policy-content li {
  margin-bottom: 0.8rem;
}

.policy-content strong {
  color: #2f353a;
}

.contact-box {
  background: #f8f9fa;
  border-left: 4px solid #321fdb;
  padding: 1.5rem;
  margin: 2rem 0;
  border-radius: 0.25rem;
}

.contact-box h3 {
  margin-top: 0;
  color: #321fdb;
}

.contact-box p {
  margin-bottom: 0;
}

.security-note {
  margin-top: 2rem;
  padding: 1rem;
  background: #e7f3ff;
  border-radius: 0.25rem;
  text-align: center;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .policy-title {
    font-size: 2rem;
  }
  
  .policy-content {
    font-size: 1rem;
  }
  
  .policy-content h2 {
    font-size: 1.5rem;
  }
  
  .policy-content h3 {
    font-size: 1.2rem;
  }
}
</style>